import { Suspense, lazy } from 'react';

import { Navigate } from 'react-router';
import { DynamicBaseBreadcrumb, DynamicSitesBreadcrumb } from '../../modules/AppBreadcrumb';
import { Spinner } from '../components';
import { AppControllerType, AppRoutes } from '../interfaces/router';

const PagesListPage = lazy(() => import('../../pages/Pages/PagesOverview.page'));
const PagesEditPage = lazy(() => import('../../pages/Pages/PagesEdit.page'));
const PagesCreatePage = lazy(() => import('../../pages/Pages/PagesCreate.page'));
const PagesDossierPage = lazy(() => import('../../pages/Pages/PagesDossier.page'));
const PageNodesEditPage = lazy(() => import('../../pages/Pages/PageNodes/PageNodesEdit.page'));
const PageNodesCreatePage = lazy(() => import('../../pages/Pages/PageNodes/PageNodesCreate.page'));
const PageLayoutViewPage = lazy(() => import('../../pages/Pages/PageLayouts/PageLayoutView.page'));
const PageLayoutCreatePage = lazy(() => import('../../pages/Pages/PageLayouts/PageLayoutCreate.page'));
const PageLayoutEditPage = lazy(() => import('../../pages/Pages/PageLayouts/PageLayoutEdit.page'));
const PageComponentViewPage = lazy(() => import('../../pages/Pages/PageComponents/PageComponentView.page'));
const PageComponentCreatePage = lazy(() => import('../../pages/Pages/PageComponents/PageComponentCreate.page'));
const PageComponentEditPage = lazy(() => import('../../pages/Pages/PageComponents/PageComponentEdit.page'));

export const PagesController: AppControllerType = {
  common: [
    {
      path: AppRoutes.Pages + '/*',
      element: (
        <Suspense fallback={ <Spinner/> }>
          <PagesListPage/>
        </Suspense>
      ),
      breadcrumb: DynamicSitesBreadcrumb.DynamicPagesListPagesBreadcrumb
    },
    {
      path: AppRoutes.PageNodes + '/*',
      element: (
        <Suspense fallback={ <Spinner/> }>
          <PagesListPage/>
        </Suspense>
      ),
      breadcrumb: DynamicSitesBreadcrumb.DynamicPagesListStructureBreadcrumb
    },
    {
      path: AppRoutes.PageNodesById + '/*',
      element: (
        <Suspense fallback={ <Spinner/> }>
          <PagesListPage/>
        </Suspense>
      ),
      breadcrumb: DynamicSitesBreadcrumb.DynamicPagesListStructureBreadcrumb
    },
    {
      path: AppRoutes.PagesEdit,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <PagesEditPage/>
        </Suspense>
      ),
      breadcrumb: DynamicBaseBreadcrumb.DynamicBaseEditBreadcrumb
    },
    {
      path: AppRoutes.PagesCreate,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <PagesCreatePage/>
        </Suspense>
      ),
      breadcrumb: DynamicBaseBreadcrumb.DynamicBaseCreateBreadcrumb
    }
  ],
  drawer: [
    {
      path: AppRoutes.PagesById,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <PagesDossierPage/>
        </Suspense>
      ),
      breadcrumb: DynamicSitesBreadcrumb.DynamicPagesByIdBreadcrumb,
      props: {
        commonDrawerWidth: 460
      }
    },
    {
      path: AppRoutes.PageNodesCreate,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <PageNodesCreatePage/>
        </Suspense>
      ),
      breadcrumb: DynamicSitesBreadcrumb.DynamicPageNodeCreateBreadcrumb,
      props: {
        commonDrawerWidth: 460
      }
    },
    {
      path: AppRoutes.PageNodesByIdEdit,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <PageNodesEditPage/>
        </Suspense>
      ),
      breadcrumb: DynamicSitesBreadcrumb.DynamicPageNodeEditBreadcrumb,
      props: {
        commonDrawerWidth: 460
      }
    },
    {
      path: AppRoutes.PageLayouts,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <Navigate to={ window.location.pathname.split('/').slice(0, 5).join('/') } replace/>
        </Suspense>
      ),
      breadcrumb: DynamicSitesBreadcrumb.DynamicPageLayoutsBreadcrumb,
      props: {
        commonDrawerWidth: 460
      }
    },
    {
      path: AppRoutes.PageLayoutsById,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <PageLayoutViewPage/>
        </Suspense>
      ),
      breadcrumb: DynamicSitesBreadcrumb.DynamicPageLayoutsByIdBreadcrumb,
      props: {
        commonDrawerWidth: 600
      }
    },
    {
      path: AppRoutes.PageLayoutsCreate,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <PageLayoutCreatePage/>
        </Suspense>
      ),
      breadcrumb: DynamicBaseBreadcrumb.DynamicBaseCreateBreadcrumb,
      props: {
        commonDrawerWidth: 600
      }
    },
    {
      path: AppRoutes.PageLayoutsByIdEdit,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <PageLayoutEditPage/>
        </Suspense>
      ),
      breadcrumb: DynamicBaseBreadcrumb.DynamicBaseEditBreadcrumb,
      props: {
        commonDrawerWidth: 600
      }
    },
    {
      path: AppRoutes.PageComponents,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <Navigate to={ window.location.pathname.split('/').slice(0, 5).join('/') } replace/>
        </Suspense>
      ),
      breadcrumb: DynamicSitesBreadcrumb.DynamicPageComponentsBreadcrumb,
      props: {
        commonDrawerWidth: 460
      }
    },
    {
      path: AppRoutes.PageComponentsById,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <PageComponentViewPage/>
        </Suspense>
      ),
      breadcrumb: DynamicSitesBreadcrumb.DynamicPageComponentsByIdBreadcrumb,
      props: {
        commonDrawerWidth: 600
      }
    },
    {
      path: AppRoutes.PageComponentsCreate,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <PageComponentCreatePage/>
        </Suspense>
      ),
      breadcrumb: DynamicBaseBreadcrumb.DynamicBaseCreateBreadcrumb,
      props: {
        commonDrawerWidth: 600
      }
    },
    {
      path: AppRoutes.PageComponentsByIdEdit,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <PageComponentEditPage/>
        </Suspense>
      ),
      breadcrumb: DynamicBaseBreadcrumb.DynamicBaseEditBreadcrumb,
      props: {
        commonDrawerWidth: 600
      }
    }
  ]
};
